import React from "react";
import classNames from "classnames";
import {motion} from "framer-motion";

export const AppLinks = (): React.ReactElement => {
    return (
        <>
            <motion.div className="bone">
                <motion.div
                    className="text-center"
                    style={{ background: "#faf8f5" }}
                    initial="hidden"
                    animate="visible"
                >
                    <section className={classNames("hero home-hero-section section has-bg-color invert-color")}>
                    </section>


                    <motion.div className="appsLinks">
                        <div>
                        <h1 className="mt-0 font-bold gradient-text mb-12">Get Our App</h1>
                        <p className="font-regular font-lg mb-8">
                            Download our app from your favorite store and stay connected.
                        </p>
                            <p className="font-regular font-lg mb-8">
                                Whether you’re using Android or iOS, our app is designed to give you
                                a smooth, reliable, and engaging experience. Join thousands of users
                                who are already taking charge of their health journey anytime,
                                anywhere.
                            </p>

                            <div className="app-buttons mb-12">
                            {/* Play Store */}
                            <a
                                href="https://play.google.com/store/apps/details?id=com.roblink.regenems"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="icons flex font-lg items-center"
                            >
                                <img className="icon" src={require("../assets/Images/playstore-img.png")} />
                            </a>

                            {/* App Store */}
                            <a
                                href="https://apps.apple.com/in/app/regen-ems/id6745080700"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="icons appStoreLink font-lg flex items-center ms-4"
                            >
                                <img className="icon" src={require("../assets/Images/appstore-img.png")} />
                            </a>
                        </div>
                        </div>

                    </motion.div>
                </motion.div>
            </motion.div>
        </>
    );
};
